import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { traceOriginalReducer } from './trace.reducer';
import { TraceOriginalSliceState, TraceSliceKey } from './trace.state';

export const TraceFeatureKey = 'Trace';

export interface TraceFeatureState {
	[TraceSliceKey]: TraceOriginalSliceState;
}

export interface TraceRootState extends IAppRootState {
	[TraceFeatureKey]: TraceFeatureState;
}

export const featureSelector =
	createFeatureSelector<TraceFeatureState>(TraceFeatureKey);

export const traceReducers: ActionReducerMap<TraceFeatureState> = {
	[TraceSliceKey]: traceOriginalReducer,
};
